module.exports = __webpack_public_path__ + "static/img/mine_phone@3x.890f07a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mine_phone@3x.png
// module id = xSyC
// module chunks = 1